import React from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import moment from 'moment';
import * as am4charts from '@amcharts/amcharts4/charts';

import { IAccessPointSignalLevelTrend } from '../../../../services/core/accessPoints';
import { Tooltip } from '../../../../components/tooltip/tooltip';
import { StackedColumnsDateChart } from '@components/chart/stackedColumnsDateChart';
import { weekendsHighlightDateAxis } from '../../../../components/chart/lib';
import { DateRange } from '..';
import './charts.css';

interface IProps {
  data: IAccessPointSignalLevelTrend[],
  dateRange: DateRange,
  onMount: (chart: am4charts.XYChart) => am4charts.XYChart
}

export const formatTooltipHour = (date: number) => {
  return moment.utc(date).format('LLLL LT');
};

export function drawAccessPointSamplesXAxisLabels(xAxis: am4charts.DateAxis, dateRange: { from: number, to: number }) {
  xAxis.dateFormatter.utc = true;
  xAxis.dateFormats.setKey("day", "dt");
  xAxis.markUnitChange = false;

  xAxis.renderer.labels.template.disabled = false;
  xAxis.renderer.labels.template.location = 0.05 as any;

  xAxis.min = moment.utc(dateRange.from).valueOf();
  xAxis.max = moment.utc(dateRange.to).valueOf();

  weekendsHighlightDateAxis(dateRange.from, dateRange.to, xAxis);

  xAxis.baseInterval = { timeUnit: "hour", count: 1 };
}

export const CoreAccessPointSamples = (props: IProps) => {
  const { data, dateRange } = props;
  const { t } = useTranslation('coreAccessPoints');

  return (
    <div className="core-access-point-chart-section">
      <StackedColumnsDateChart<IAccessPointSignalLevelTrend>
        data={data}
        className="core-ap-samples-by-time-chart"
        series={[{
          dataKey: 'sampleCount',
          description: t('SAMPLES_PER_HOUR'),
          visible: true,
          colour: '#5b9ad2',
        }]}
        title={
          <>
            {t('SAMPLES_BY_TIME')}{' '}
            <Tooltip popperContent={t('SAMPLES_BY_TIME_TOOLTIP')} placement="right">
              <i className="fa fa-question-circle" style={{ color: '#7490b9', cursor: 'pointer' }} />
            </Tooltip>
          </>
        }
        columnWidth={10}
        onMount={props.onMount}
        days={30}
        xAxisType={'date'}
        yAxisType={'value'}
        formatTooltipDate={formatTooltipHour}
        cypressId={'coreAccessPointSamplesByTime'}
        hasLegend={true}
        drawXAxis={(_, xAxis) => drawAccessPointSamplesXAxisLabels(xAxis as am4charts.DateAxis, dateRange)}
        useAxisTooltip
        bottomBorder
      />
    </div>
  );
};
